/**
 * Shared visual tokens for the dashboard (single source of truth).
 */
export const THEME_PRIMARY = "#1976d2";
export const THEME_PRIMARY_HOVER = "#1565c0";
export const THEME_PRIMARY_LIGHT = "#e3f2fd";

export const dash = {
  pageBg: "#ffffff",
  surface: "#ffffff",
  border: "rgba(15, 23, 42, 0.08)",
  borderStrong: "rgba(15, 23, 42, 0.12)",
  textMuted: "rgba(15, 23, 42, 0.55)",
  textSubtle: "#94a3b8",
  accent: THEME_PRIMARY,
  accentSoft: "rgba(25, 118, 210, 0.08)",
  success: "#16a34a",
  successSoft: "rgba(22, 163, 74, 0.1)",
  warning: "#d97706",
  warningSoft: "rgba(217, 119, 6, 0.1)",
  error: "#dc2626",
  errorSoft: "rgba(220, 38, 38, 0.1)",
  shadowSm: "0 1px 2px rgba(15, 23, 42, 0.04), 0 4px 16px rgba(15, 23, 42, 0.05)",
  shadowMd: "0 4px 20px rgba(15, 23, 42, 0.08)",
  shadowHover: "0 12px 32px rgba(25, 118, 210, 0.12)",
  radius: 2.5,
  radiusLg: 3,
  maxContentWidth: 1440,
  gridGap: 2.5,
  sectionGap: 4,
  cardPadding: { xs: 2, sm: 2.5 },
  kpiMinHeight: 132,
  chartMinHeight: 280,
  transition: "0.2s cubic-bezier(0.4, 0, 0.2, 1)",
  headerBand: "#0d47a1",
  headerHeroGradient: "linear-gradient(90deg, #1565c0 0%, #1976d2 100%)",
};
